import { AppointmentSlot } from "#/decision_tree_viewer/models/appointment-slot";
import { BaseDecisionTreeViewerApi } from "./base";

class AppointmentSlotApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ model: AppointmentSlot, baseURL: "/ehr_appointment_slots" });
  }
}

let api;

export const createAppointmentSlotApi = () => {
  api ??= new AppointmentSlotApi();

  return {
    find: async (id) => api.get(id.toString()),
  };
};
